import checkbox from '../../../../checkbox';

const light = (params) => checkbox.switchedOn.background.default.light(params);

export default light;
